const SmsStar = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M19.5119 10.5751V13.9799C19.5119 16.9591 17.8095 18.2359 15.256 18.2359H6.74405C4.19048 18.2359 2.4881 16.9591 2.4881 13.9799V8.02158C2.4881 5.04241 4.19048 3.76562 6.74405 3.76562H11"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.74405 8.44727L9.40828 10.5752C10.285 11.2732 11.7235 11.2732 12.6002 10.5752"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.366 3.18706L17.6044 3.67223C17.7235 3.91056 18.0215 4.13188 18.2853 4.18295L18.6088 4.23402C19.5791 4.39575 19.809 5.11075 19.111 5.81723L18.8131 6.11514C18.6173 6.31943 18.5066 6.71098 18.5662 6.98336L18.6088 7.16212C18.8726 8.33676 18.2513 8.78788 17.2299 8.17502L17.0085 8.04735C16.7447 7.89414 16.3191 7.89414 16.0552 8.04735L15.8339 8.17502C14.8039 8.79639 14.1826 8.33676 14.455 7.16212L14.4975 6.98336C14.5571 6.71098 14.4465 6.31943 14.2507 6.11514L13.9528 5.81723C13.2548 5.11075 13.4846 4.39575 14.455 4.23402L14.7784 4.18295C15.0338 4.14039 15.3402 3.91056 15.4594 3.67223L15.6977 3.18706C16.1573 2.25926 16.9064 2.25926 17.366 3.18706Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SmsStar;
